export default __webpack_public_path__ + "static/media/gold-badge.0960cc39.svg";